import "jquery-keyboard-trap/jquery.keyboardtrap";

'use strict';

/* globals $: false */
(function () {
    console.log("design system components");
});


/*! politespace - v0.1.5 - 2015-07-09
Politely add spaces to input values to increase readability (credit card numbers, phone numbers, etc).
 * https://github.com/filamentgroup/politespace
 * Copyright (c) 2015 Filament Group (@filamentgroup)
 * MIT License */
// TODO when moving to import system, install this with npm install politespace
(function (w) {
    //Clear cached search criteria 
	"use strict";
	var Politespace = function( element ) {
		if( !element ) {
			throw new Error( "Politespace requires an element argument." );
		}

		if( !element.getAttribute ) {
			// Cut the mustard
			return;
		}

		this.element = element;
		this.type = this.element.getAttribute( "type" );
		this.delimiter = this.element.getAttribute( "data-delimiter" ) || " ";
		// https://en.wikipedia.org/wiki/Decimal_mark
		this.decimalMark = this.element.getAttribute( "data-decimal-mark" ) || "";
		this.reverse = this.element.getAttribute( "data-reverse" ) !== null;
		this.groupLength = this.element.getAttribute( "data-grouplength" ) || 3;
	};

	Politespace.prototype._divideIntoArray = function( value ) {
		var split = ( '' + this.groupLength ).split( ',' ),
			isUniformSplit = split.length === 1,
			dividedValue = [],
			loopIndex = 0,
			groupLength,
			substrStart,
			useCharCount;

		while( split.length && loopIndex < value.length ) {
			if( isUniformSplit ) {
				groupLength = split[ 0 ];
			} else {
				// use the next split or the rest of the string if open ended, ala "3,3,"
				groupLength = split.shift() || value.length - loopIndex;
			}

			// Use min if we're at the end of a reversed string
			// (substrStart below grows larger than the string length)
			useCharCount = Math.min( parseInt( groupLength, 10 ), value.length - loopIndex );

			if( this.reverse ) {
				substrStart = -1 * (useCharCount + loopIndex);
			} else {
				substrStart = loopIndex;
			}
			dividedValue.push( value.substr( substrStart, useCharCount ) );
			loopIndex += useCharCount;
		}

		if( this.reverse ) {
			dividedValue.reverse();
		}

		return dividedValue;
	};

	Politespace.prototype.format = function( value ) {
		var split;
		var val = this.unformat( value );
		var suffix = '';

		if( this.decimalMark ) {
			split = val.split( this.decimalMark );
			suffix = split.length > 1 ? this.decimalMark + split[ 1 ] : '';
			val = split[ 0 ];
		}

		return this._divideIntoArray( val ).join( this.delimiter ) + suffix;
	};

	Politespace.prototype.trimMaxlength = function( value ) {
		var maxlength = this.element.getAttribute( "maxlength" );
		// Note input type="number" maxlength does nothing
		if( maxlength ) {
			value = value.substr( 0, maxlength );
		}
		return value;
	};

	Politespace.prototype.getValue = function() {
		return this.trimMaxlength( this.element.value );
	};

	Politespace.prototype.update = function() {
		this.element.value = this.useProxy() ? this.getValue() : this.format( this.getValue() );
	};

	Politespace.prototype.unformat = function( value ) {
		return value.replace( new RegExp(  this.delimiter, 'g' ), '' );
	};

	Politespace.prototype.reset = function() {
		this.element.value = this.unformat( this.element.value );
	};

	Politespace.prototype.useProxy = function() {
		return this.type === "number";
	};

	Politespace.prototype.updateProxy = function() {
		var proxy;
		if( this.useProxy() ) {
			proxy = this.element.parentNode.firstChild;
			proxy.innerHTML = this.format( this.getValue() );
			proxy.style.width = this.element.offsetWidth + "px";
		}
	};

	Politespace.prototype.createProxy = function() {
		if( !this.useProxy() ) {
			return;
		}

		function getStyle( el, prop ) {
			return window.getComputedStyle( el, null ).getPropertyValue( prop );
		}
		function sumStyles( el, props ) {
			var total = 0;
			for( var j=0, k=props.length; j<k; j++ ) {
				total += parseFloat( getStyle( el, props[ j ] ) );
			}
			return total;
		}

		var parent = this.element.parentNode;
		var el = document.createElement( "div" );
		var proxy = document.createElement( "div" );
		proxy.style.font = getStyle( this.element, "font" );
		proxy.style.paddingLeft = sumStyles( this.element, [ "padding-left", "border-left-width" ] ) + "px";
		proxy.style.paddingRight = sumStyles( this.element, [ "padding-right", "border-right-width" ] ) + "px";
		proxy.style.top = sumStyles( this.element, [ "padding-top", "border-top-width", "margin-top" ] ) + "px";

		el.appendChild( proxy );
		el.className = "politespace-proxy active";
		var formEl = parent.replaceChild( el, this.element );
		el.appendChild( formEl );

		this.updateProxy();
	};

	window.Politespace = Politespace;

}( this ));

(function( $ ) {
	"use strict";

	// jQuery Plugin

	var componentName = "politespace",
		enhancedAttr = "data-enhanced",
		initSelector = "[data-" + componentName + "]:not([" + enhancedAttr + "])";

	$.fn[ componentName ] = function(){
		return this.each( function(){
			var polite = new Politespace( this );
			if( polite.type === "number" ) {
				polite.createProxy();
			}

			$( this )
				.bind( "input keydown", function() {
					polite.updateProxy();
				})
				.bind( "blur", function() {
					$( this ).closest( ".politespace-proxy" ).addClass( "active" );
					polite.update();
					polite.updateProxy();
				})
				.bind( "focus", function() {
					$( this ).closest( ".politespace-proxy" ).removeClass( "active" );
					polite.reset();
				})
				.data( componentName, polite );

			polite.update();
		});
	};

	// auto-init on enhance (which is called on domready)
    $(document).ready(function() {
        $('[data-' + componentName + ']').politespace();
    });

}( jQuery ));

/**
 * Accordion
 *
 * An accordion component.
 *
 * @param {jQuery} $el A jQuery html element to turn into an accordion.
 */
function Accordion($el) {
  var self = this;
  this.$root = $el;
    this.$root.on('click', 'button.usa-accordion-button, [data-type="usa-accordion-button"]', function (ev) {
      var action = $(this).data('button-action');
      if (action !== 'no-toggle') {
          var expanded = JSON.parse($(this).attr('aria-expanded'));
          var multiselect = $(this).closest("[data-multiselectable]").data("multiselectable");
          ev.preventDefault();
          if (multiselect !== true) {
              self.hideAll();
          }
          if (!expanded) {
              self.show($(this));
              if (multiselect !== true) {
                  self.jumpTo($(this));
              }
          } else if (multiselect === true) {
              self.hide($(this));
          }
      }
  });
}

Accordion.prototype.$ = function (selector) {
    return this.$root.find(selector);
};

Accordion.prototype.jumpTo = function ($button) {
    var buttonClass = $button.attr('class');
    if (buttonClass.indexOf("search") === -1) {
        var btnid = $button.attr('aria-controls');
        var scroll = $("#" + btnid).offset().top - 100;
        $('html,body').animate({
            scrollTop: scroll
        }, 'slow');
    }
};

Accordion.prototype.hide = function($button) {
  var selector = $button.attr('aria-controls'),
      $content = this.$('#' + selector);

  $button.attr('aria-expanded', false);
  $content.attr('aria-hidden', true);
};

Accordion.prototype.show = function($button) {
  var selector = $button.attr('aria-controls'),
      $content = this.$('#' + selector);

  $button.attr('aria-expanded', true);
  $content.attr('aria-hidden', false);
};

Accordion.prototype.hideAll = function (ev) {
  var self = this;
  this.$('button').each(function (e) {
      self.hide($(this));
  });
};

Accordion.prototype.showAll = function (ev) {
    var self = this;
    this.$('button').each(function (e) {
        self.show($(this));
    });
}

Accordion.prototype.toggleAll = function (ev) {
    const elem = ev.target;
    let state = elem.getAttribute('data-state');
    if (state === undefined || state === null || state === 'collapsed') {
        this.showAll();
        elem.setAttribute('data-state', 'expanded');
        elem.innerHTML = "Collapse all";
    }
    else if (state === 'expanded') {
        this.hideAll();
        elem.setAttribute('data-state', 'collapsed');
        elem.innerHTML = "Expand all";
    }
}

/**
 * accordion
 *
 * Initialize a new Accordion component.
 *
 * @param {jQuery} $el A jQuery html element to turn into an accordion.
 */
function accordion($el) {
    const a = new Accordion($el);
    if ($el.hasClass('usa-accordion') || $el.hasClass('usa-accordion-bordered')) {
        if ($el[0]?.id === undefined || $el[0]?.id === null || $el[0]?.id.trim() === '') {
            return a;
        }
        const t = document.querySelector(`[data-object="accordion-toggle-all"][aria-controls="${$el[0].id}"]`);
        t.addEventListener('click', ev => {
            a.toggleAll(ev);
            ev.preventDefault();
        });
    }
    return a;
}

function togglePassword($el) {
  var fieldSelector =  '#' + $el.attr('aria-controls'),
      $field = $el.parents('form').find(fieldSelector),
      showing = false;

  $el.on('click', function(ev) {
    ev.preventDefault();
    toggleFieldMask($field, showing);
    $el.text(showing ? 'Show password' : 'Hide password');
    showing = !showing;
  });
}

function toggleSSN($el) {
  var fieldSelector =  '#' + $el.attr('aria-controls'),
      $field = $el.parents('form').find(fieldSelector),
      showing = false;

  $el.on('click', function(ev) {
    ev.preventDefault();
    toggleFieldMask($field, showing);
    $el.text(showing ? 'Show SSN' : 'Hide SSN');
    showing = !showing;
  });
}

function toggleMultiPassword($el) {
  var fieldSelector = '#password, #confirmPassword',
      $fields = $el.parents('form').find(fieldSelector),
      showing = false;

  $el.on('click', function(ev) {
    ev.preventDefault();
    toggleFieldMask($fields, showing);
    $el.text(showing ? 'Show my typing' : 'Hide my typing');
    showing = !showing;
  });
}

function toggleFieldMask($field, showing) {
  $field.attr('autocapitalize', 'off');
  $field.attr('autocorrect', 'off');
  $field.attr('type', showing ? 'password' : 'text');
}

function validator($el) {
  var data = $('#password[data-validation-element]').data(),
      key,
      validatorName,
      validatorPattern,
      $validatorCheckbox,
      $checkList = $($el.data('validationElement'));

  function validate() {
    for (key in data) {
      if (key.startsWith('validate')) {
        validatorName = key.split('validate')[1];
        validatorPattern = new RegExp(data[key]);
        $validatorCheckbox = $checkList.find('[data-validator=' +
            validatorName.toLowerCase() + ']');

        if (!validatorPattern.test($el.val())) {
          $validatorCheckbox.toggleClass('usa-checklist-checked', false);
        }
        else {
          $validatorCheckbox.toggleClass('usa-checklist-checked', true);
        }
      }
    }
  }

  $el.on('keyup', validate);
}

$(function () {

    $('[class^=usa-accordion]').each(function () {
        accordion($(this));
    });
    
    var $footer = $('[data-object="footer"]'),
    window_width = window.innerWidth;

    $footer.on('click', '[data-behavior]', function () {
        var $el = $(this),
          $object = $el.closest('[data-object="footer"]'),
          state = $el.attr('data-state'),
          behavior = $el.attr('data-behavior'),
          $target = $object.find($el.attr('data-target'));

        $el.blur(); // Removes focus

        // Each behavior attached to the element should be triggered
        $.each(behavior.split(' '), function (idx, action) {
            $object.trigger(action, { el: $el, object: $object, state: state, target: $target });
        });
    });

    $footer.on('footer.toggle', function (event, opts) {
        event.preventDefault();

        if (opts.state === 'is-closed') {
            opts.object.trigger('footer.open', opts);
        } else if (opts.state === 'is-open') {
            opts.object.trigger('footer.close', opts);
        }
    });

    $footer.on('footer.open', function (event, opts) {
        // Hide all siblings
        /*
        opts.object
          .find('[data-behavior="footer.toggle"][data-state="is-open"]')
          .trigger('close', { });
        */

        opts.target.removeClass('is-hidden');
        opts.target.attr('aria-expanded', 'true');
        opts.el.attr('aria-expanded', 'true');
        opts.el.attr('data-state', 'is-open');
    });

    $footer.on('footer.close', function (event, opts) {
        if (window_width < 600) {
            event.preventDefault();

            opts.target.addClass('is-hidden');
            opts.target.attr('aria-expanded', 'false');
            opts.el.attr('aria-expanded', 'false');
            opts.el.attr('data-state', 'is-closed');
        }
    });

  // Fixing skip nav focus behavior in chrome
  $('.skipnav').click(function(){
    $('#main-content').attr('tabindex','0');
  });

  $('#main-content').blur(function(){
    $(this).attr('tabindex','-1');
  });

  togglePassword($('.usa-show_password'));
  toggleMultiPassword($('.usa-show_multipassword'));
  toggleSSN($('.usa-show_ssn'));
  validator($('.js-validate_password'));

});

// Document - Object for uploading, viewing, and editing documents

var $doc = $('[data-object="document"]');

$doc.on('click', '[data-behavior]', function (event) {
  var $el = $(this),
    $object = $el.closest('[data-object="document"]'),
    behavior = $el.attr('data-behavior'),
    state = $object.attr('data-state'),
    $target = $object.find($el.attr('data-target'));

  event.preventDefault();
  $el.blur(); // Removes focus

  // Each behavior attached to the element should be triggered
  $.each(behavior.split(' '), function (idx, action) {
    $el.trigger(action, { el: $el, object: $object, state: state, target: $target });
  });
});

$doc.on('document.toggle', function(event, opts) {
  var $input = opts.object.find('#' + opts.target.attr('for'));

  event.preventDefault();

  // This event is fired by the figure and clicks the checkbox
  opts.target.trigger('click');

  if (opts.state !== 'is-disabled') {
    if ($input.is(':checked')) {
      opts.object.attr('data-state', 'is-selected');
    } else {
      opts.object.attr('data-state', 'is-selectable');
    }
  }
});

// Modal

global.$modal = $('[data-object="modal"]');
global.$body = $('body');
global.$backdrop = $('<div class="usajobs-modal__canvas-blackout" tabindex="-1" />');
var modal = document.querySelectorAll('[data-object="modal"]');
$(document).on('click', '[data-object-trigger="modal"]', function (event) {
  var $el = $(this),
    $this_modal = $body.find($el.attr('data-target')),
    state = $this_modal.attr('data-state'),
    transition_to;

  event.preventDefault();

  if (state === 'is-closed') {
    transition_to = 'modal.open';
  } else {
    transition_to = 'modal.close';
  }

  $this_modal[0].dispatchEvent(new CustomEvent(transition_to, { 'detail': { el: $el, object: $this_modal, state: state } }));
});

for (var i = 0; i < modal.length; i++) {
    let modalComponents = modal[i].querySelectorAll("[data-behavior]");
    for (var j = 0; j < modalComponents.length; j++) {
        modalComponents[j].addEventListener("click", function (event) {
            var $el = $(this),
                $object = $el.closest('[data-object="modal"]'),
                state = $object.attr('data-state'),
                behavior = $el.attr('data-behavior');

            event.preventDefault();
            $el.blur(); // Removes focus

            // Each behavior attached to the element should be triggered
            $.each(behavior.split(' '), function (idx, action) {
                $object[0].dispatchEvent(new CustomEvent(action, { 'detail': { el: $el, object: $object, state: state } }));
            });
        });
    }

    modal[i].addEventListener("modal.open", function (event) {
        var closeModal = function () {
            event.detail.object[0].dispatchEvent(new CustomEvent('modal.close', {
                'detail':
                {
                    el: event.detail.el,
                    object: event.detail.object,
                    state: event.detail.state
                }
            }));
        };
        event.preventDefault();
        $body.addClass('is-open-modal');
        $backdrop
            .appendTo($body)
            .attr('aria-hidden', 'true');

        // Store the element on the page that had focus
        // so we can return focus to that element
        event.detail.object.data('previous_focus', $(':focus'));
        event.detail.object.attr('data-state', 'is-open');
        event.detail.object.attr('aria-hidden', 'false');

        $(document).on('keyup', function (e) {
            // Close the modal when ESC is pressed
            if (e.keyCode === 27) {
                closeModal();
            }
        });

        /*** QQ Customization: adding accessiblity by setting focus and drapping the tabs ***/
        var _id = "#" + $(this).attr('id');
        setInitialFocusModal(_id);
        $.trapKeyboard($(_id));
    });

    modal[i].addEventListener("modal.close", function (event) {
        $body.removeClass('is-open-modal');
        $backdrop.remove();

        $(document).off('keyup');
        event.detail.object.attr('data-state', 'is-closed');
        event.detail.object.attr('aria-hidden', 'true');
        var previousFocus = event.detail.object.data('previous_focus');
        if (previousFocus) {
            previousFocus.focus();
        }
    });
}

// Navigation (top-level-nav)
global.$nav = $('[data-object="nav"]');
global.closeNavOnLoad = function ($nav_bar) {
    var width = window.innerWidth,
        $trigger = $nav_bar.find('[data-behavior="nav.menu.search-toggle"]'),
        $parent = $trigger.parent(),
        state = $parent.attr('data-state'),
        $menu = $nav_bar.find('#' + $trigger.attr('aria-controls'));

    if (width >= 600 && state === 'is-closed') {
        $nav.trigger('nav.menu.slide-open', { parent: $parent, menu: $menu });
    }
};

$nav.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
        $object = $el.closest('[data-object="nav"]'),
        behavior = $el.attr('data-behavior'),
        $target = $(window.document).find('#' + $el.attr('aria-controls')),
        state = $target.attr('aria-expanded'),
        $sibling = $target.siblings('[role="menu"]');
    event.preventDefault();
    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^nav/)) {
            $el.trigger(action, { el: $el, object: $object, state: state, target: $target, sibling: $sibling });
        }
    });
});

$nav.on('nav.toggle', function (event, opts) {
    event.preventDefault();
    if (opts.state === 'is-closed') {
        opts.object.trigger('nav.open', opts);
    } else if (opts.state === 'is-open') {
        opts.object.trigger('nav.close', opts);
    }
});

$nav.on('nav.open', function (event, opts) {
    opts.object.attr('data-state', 'is-open');
    opts.target.slideToggle(300, function () {
        opts.el.attr('aria-expanded', 'true');
        opts.target.attr('aria-expanded', 'true');
    });
});

$nav.on('nav.close', function (event, opts) {
    opts.object.attr('data-state', 'is-closed');
    opts.target.slideToggle(300, function () {
        opts.el.attr('aria-expanded', 'false');
        opts.target.attr('aria-expanded', 'false');
    });
});

$nav.on('nav.menu.toggle', function (event, opts) {
    var $parent = opts.el.parent(),
      parent_state = $parent.attr('data-state'),
      $menu = $parent.find('[role="menu"]'),
      $sibling = $parent.siblings().find('[aria-expanded="true"]');

    event.preventDefault();

    $nav.trigger('nav.menu.slide-close', { parent: $sibling.parent(), menu: $sibling });

    if (parent_state === 'is-closed') {
        $nav.trigger('nav.menu.slide-open', { parent: $parent, menu: $menu });
    } else if (parent_state === 'is-open') {
        $nav.trigger('nav.menu.slide-close', { parent: $parent, menu: $menu });
    }
});

$nav.on('nav.menu.slide-open', function (event, opts) {
    opts.parent.attr('data-state', 'is-open');
    opts.menu.slideDown(300, function () {
        opts.menu.attr('data-expanded', 'true');
    });
});

$nav.on('nav.menu.slide-close', function (event, opts) {
    opts.parent.attr('data-state', 'is-closed');
    opts.menu.slideUp(300, function () {
        opts.menu.attr('data-expanded', 'false');
        if (opts.callback !== undefined) {
            opts.callback(opts);
        }
    });
});

$nav.on('nav.menu.search-toggle', function (event, opts) {      
    var $parent = opts.el.parent(),
        $triggering_menu,
        reinstateActiveMenu = function reinstateActiveMenu(menuOpts) {
            var $sibling_trigger;

            if (menuOpts.sibling !== undefined && menuOpts.sibling.length > 0) {
                menuOpts.sibling.slideDown(300, function () {
                    menuOpts.sibling.attr('data-expanded', 'true');
                });

                $sibling_trigger = menuOpts.object.find('#' + menuOpts.el.attr('data-state-triggering-menu'));
                $sibling_trigger.addClass('is-active');
            }
        };  

    if (opts.target.attr('data-expanded') === 'false') {
        if (opts.sibling !== undefined && opts.sibling.length > 0) {
            opts.sibling.slideUp(300, function () {
                opts.sibling.attr('data-expanded', 'false');
            });

            // Find active menu siblings, retain them for making them active again on next toggle
            $triggering_menu = opts.el.parent().siblings().find('.is-active');
            $triggering_menu.removeClass('is-active');
            opts.el.attr('data-state-triggering-menu', $triggering_menu.attr('id'));
        }
        $nav.trigger('nav.menu.slide-open', { parent: $parent, menu: opts.target });
        opts.el.attr('aria-expanded', 'true');
    } else if (opts.target.attr('data-expanded') === 'true') {      
        $nav.trigger('nav.menu.slide-close', { parent: $parent, menu: opts.target, el: opts.el, sibling: opts.sibling, object: opts.object, callback: reinstateActiveMenu });
        opts.el.attr('aria-expanded', 'false');
    }
});

$(document).ready(function () {
    if ($nav !== undefined && $nav.length > 0) {
        $.each($nav, function (idx, nav) {
            var $nav_bar = $(nav);
            if ($nav_bar.attr('data-behavior') !== undefined) {
                if ($nav_bar.attr('data-behavior') === 'closeOnLoad') {
                    closeNavOnLoad($nav_bar);
                }
            }
        });
    }
    
});

$(window).resize(() => throttle(250, function () {
    if ($nav !== undefined && $nav.length > 0) {
        $.each($nav, function (idx, nav) {
            var $nav_bar = $(nav);
            if ($nav_bar.attr('data-behavior') !== undefined) {
                if ($nav_bar.attr('data-behavior') === 'closeOnLoad') {
                    closeNavOnLoad($nav_bar);
                }
            }
        });
    }
}));

// Notification

var $notification = $('[data-object="notification"]'),
  $notification_trigger = $('[data-object-trigger="notification"]'),
  $body = $('body');

$notification_trigger.on('click', function (event) {
  var $el = $(this),
    $this_notification = $body.find($el.attr('data-target')),
    state = $this_notification.attr('data-state'),
    transition_to;

  event.preventDefault();

  if (state === 'is-closed') {
    transition_to = 'notification.open';
  } else {
    transition_to = 'notification.close';
  }

  $this_notification.trigger(transition_to, { el: $el, object: $this_notification, state: state });
});

$notification.on('click', '[data-behavior]', function (event) {
  var $el = $(this),
    $object = $el.closest('[data-object="notification"]'),
    state = $object.attr('data-state'),
    behavior = $el.attr('data-behavior');

  event.preventDefault();
  $el.blur(); // Removes focus

  // Each behavior attached to the element should be triggered
  $.each(behavior.split(' '), function (idx, action) {
    $el.trigger(action, { el: $el, object: $object, state: state });
  });
});

$notification.on('notification.open', function(event, opts) {
  event.preventDefault();

  opts.object.attr('data-state', 'is-open');
  opts.object.attr('aria-hidden', 'false');

  opts.object.trigger('notification.delayed-close', {
    el: opts.el,
    object: opts.object,
    state: opts.state
  });
});

$notification.on('notification.close', function(event, opts) {
  opts.object.attr('data-state', 'is-closed');
  opts.object.attr('aria-hidden', 'true');
});

$notification.on('notification.delayed-close', function(event, opts) {
  setTimeout(function () {
    opts.object.attr('data-state', 'is-closed');
    opts.object.attr('aria-hidden', 'true');
  }, 5000);
});

// JOA Actions
var $joa_actions = $(document),
  cleanUpShare = function ($list) {
      $list.children().show();
      $list.find('.link').show();
      $list.find('.short-url').remove();
  };

$joa_actions.on('click', '[data-behavior]', function () {
    var $el = $(this),
      $object = $el.closest('[data-object="joa-actions"]'),
      behavior = $el.attr('data-behavior');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^joa-actions/)) {
            $el.trigger(action, { el: $el, object: $object });
        }
    });
});

$joa_actions.on('joa-actions.toggle-save', function (event, opts) {
    var saved_state = opts.el.attr('data-state');

    event.preventDefault();

    if (saved_state === 'is-saved') {
        opts.el.text('Save');
        opts.el.attr('data-state', 'is-unsaved');
    } else {
        opts.el.text('Saved');
        opts.el.attr('data-state', 'is-saved');
    }
});

$joa_actions.on('joa-actions.shorten-link', function (event, opts) {
    var base_url = 'https://go.usa.gov/api/shorten.jsonp',
      params = [
        { name: 'login', value: 'dev-usajobs' },
        { name: 'apiKey', value: '509326519e75e35f4355498bca0a31e2' }
      ],
      url_to_encode = opts.el.attr('data-shorten-url'),
      fixedEncodeURI = function (str) {
          // Reserves square brackets for IPv6 which follows RFC3986
          return encodeURI(str).replace(/%5B/g, '[').replace(/%5D/g, ']');
      },
      short_url;

    event.preventDefault();

    params.push({ name: 'longUrl', value: fixedEncodeURI(url_to_encode) });

    // This should be the list that holds the share elements
    // Not really disabled but it will appear so until the result comes back
    opts.el.parent().parent().addClass('is-disabled');

    $.ajax({
        url: base_url,
        dataType: 'jsonp',
        crossdomain: true,
        data: $.param(params),
        success: function (rsp) {
            short_url = rsp.response.data.entry[0].short_url;

            // Hide other sharing options to make space to show the short URL
            $.each(opts.el.parent().siblings(), function (idx, sibling) {
                $(sibling).hide();
            });
            opts.el.after('<span class="short-url">' + short_url + '</span>');
            opts.el.hide();
            opts.el.parent().parent().removeClass('is-disabled');
        },
        error: function () {
        }
    });
});

$joa_actions.on('joa-actions.toggle-share', function (event, opts) {
    var target_id = opts.el.attr('id'),
      $target = $('[aria-labeledby="' + target_id + '"]'),
      state = $target.attr('aria-hidden');
    if (state === 'true') {
        $target.attr('aria-hidden', false);
    } else {
        $target.attr('aria-hidden', true);
        cleanUpShare($target);
    }
});

$joa_actions.on('joa-actions.close-share', function (event, opts) {
    var target_id = opts.el.attr('data-target'),
      $target = opts.object.find(target_id), 
      state = $target.attr('aria-hidden');

    if (state === 'true') {
        $target.attr('aria-hidden', false);
    } else {
        $target.attr('aria-hidden', true);
        cleanUpShare($target);
    }
});

var showPanel = function showPanel() {
    var list = this.closest(".usa-footer-big nav ul");
    list.classList.remove("hidden");

    var lists = list.closest(".usa-footer-big").querySelectorAll('ul');

    $.each(lists, function () {
        if ($(this)[0] !== list) {
            $(this).addClass("hidden");
        }
    });
};

$(document).on("click", ".usa-footer-big nav .usa-footer-primary-link", showPanel);

var resize = function () {
    var hidden = window.innerWidth < 600;
    $(".usa-footer-big nav ul").each(function () {
        $(this).toggleClass("hidden", hidden);
    });
};

resize();
